(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('reporting-agence', {
            parent: 'entity',
            url: '/reporting-agence',
            data: {
                authorities: ['ROLE_READ_ONLY'],
                pageTitle: 'wamasysApp.reportingAgence.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/reporting-agence/reporting-agence.html',
                    controller: 'ReportingAgenceController',
                    controllerAs: 'vm'
                }
            },

            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('reportingGlobal');
                    $translatePartialLoader.addPart('zoneAnalysis');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('contrat');
                    return $translate.refresh();
                }]
            }
        });
    }

})();
